Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.default = {
    CAR: React.createElement("span", null, "Insuring your car couldn't be simpler. Your policy could be in your inbox in 5 minutes."),
    BIKE: (React.createElement("span", null,
        "80% of our customers insure their bike online in less than 3 minutes.",
        React.createElement("span", { className: "font--block" },
            "\u00A0No Inspection required. It's ",
            React.createElement("i", null, "that"),
            " simple."))),
    HEALTH: React.createElement("span", null, "Tailor-made plans, filtered down just for your requirements."),
    HEALTH_SUPER_TOPUP: React.createElement("span", null, "Upgrade your existing policy cover by Rs. 10 Lacs for premium as less as Rs. 878."),
    TRAVEL: React.createElement("span", null, "Travel plans that are so cheap, you'd not think twice before making a trip."),
    ULIP: React.createElement("span", null, "Creating wealth and securing future couldn't be simpler."),
    TRAVEL_MULTITRIP: React.createElement("span", null, "One policy, multiple trips. Globetrotting made easy."),
    TERM_LIFE: React.createElement("span", null, "Take care of your family even when you aren't around. Compare top rated Term plans now."),
};
